const EVENT_NAME = "change_language";

interface IChangeLanguageEventPayload {
  language: string;
  newLanguage: string;
}

function changeLanguageEvent({
  language,
  newLanguage,
}: IChangeLanguageEventPayload) {
  window.gtag?.("event", EVENT_NAME, {
    site_language: language.toUpperCase(),
    new_site_language: newLanguage.toUpperCase(),
  });

  window.rdt?.("track", "Custom", { customEventName: EVENT_NAME });
}

export default changeLanguageEvent;
